import store from '@/store'
import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators'
import SelectOption from '@/models/interface/SelectOption'
import Api from '@/models/Api'
import Agreement from '@/models/Agreement'
import PaginateOptions from '@/models/interface/PaginateOptions'

@Module({
  dynamic: true, store, namespaced: true, name: 'agreement',
})
export default class AgreementModule extends VuexModule {
    public data: Agreement[] = [];

    public options: SelectOption[] = [];

    public synchronized: boolean = false;

    public get api() {
      return new Api(false)
    }

    @Mutation
    public setSynchronized(status: boolean) {
      this.synchronized = status
    }

    @Mutation
    public update(agreements: Agreement | Agreement[]) {
      let data: Array<Agreement> = []
      if (agreements instanceof Agreement) {
        data.push(agreements)
      } else {
        data = agreements
      }

      let result = this.data

      data.forEach((agreement: Agreement) => {
        let found: boolean = false
        result = result.map((obj: Agreement) => {
          if (obj.id == agreement.id) {
            found = true
            return agreement
          }
          return obj
        })

        if (!found) {
          result.push(agreement)
        }
      })

      this.data = result
    }

    @Mutation
    public delete(agreements: Agreement | Agreement[]) {
      let data: Array<Agreement> = []
      if (agreements instanceof Agreement) {
        data.push(agreements)
      } else {
        data = agreements
      }

      let result = this.data

      data.forEach((agreement: Agreement) => {
        result = result.filter((obj: Agreement) => obj.id != agreement.id)
      })

      this.data = result
    }

    @Action
    public async find(id: string): Promise<Agreement | null> {
      return new Promise(resolve => {
        const o = this.data.find(agreement => agreement.id === id)

        if (o instanceof Agreement) {
          resolve(o)
        } else {
          return this.api.get(`agreement/${id}`)
            .then(response => {
              // Parse & cache data
              const data = Agreement.toObject(response.data.result.agreement)

              if (data instanceof Agreement) {
                resolve(data)
              }
            }).catch(() => {
              resolve(null)
            })
        }
      })
    }

    @Action
    public async paginate(options: PaginateOptions) {
      return this.api.get('agreements/paginate', options)
        .then(response => {
          // Parse & cache data
          const data = Agreement.toObjectList(response.data.result.agreements)

          return {
            records: response.data.result.records,
            data,
          }
        }).catch(() => ({
          records: 0,
          data: [],
        }))
    }
}
